export default "__VITE_ASSET__DBMzGREF__"